"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyPaymentInfo = void 0;
var React = require("react");
var MonthlyPaymentInfo = /** @class */ (function () {
    function MonthlyPaymentInfo() {
    }
    MonthlyPaymentInfo.renderMonthlyPaymentInfo = function () {
        return (React.createElement("div", { className: "banner banner-info" },
            React.createElement("p", { className: "mb-0" },
                "The cost of your insurance and the interest charged is spread over the year, so paying for your insurance ",
                React.createElement("span", { className: "font-weight-bold" }, "monthly will cost more than if you paid annually"),
                ". Please check you can afford the monthly payments.",
                React.createElement("br", null),
                "You'll just need your bank details ready so we can set up a Direct Debit for you.")));
    };
    return MonthlyPaymentInfo;
}());
exports.MonthlyPaymentInfo = MonthlyPaymentInfo;
//# sourceMappingURL=MonthlyPaymentInfo.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/common/MonthlyPaymentInfo.js
// module id = 1239
// module chunks = 0